/**
 * Recently Viewed Products Tracker
 * Automatically tracks products when users visit product pages
 */

(function() {
  'use strict';
  
  // Check if we're on a product page
  function isProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }
  
  // Get product handle from URL
  function getProductHandleFromURL() {
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^\/\?]+)/);
    return match ? match[1] : null;
  }
  
  // Get product data from page
  function getProductData() {
    // Try to get from meta tags
    const productHandle = getProductHandleFromURL();
    if (!productHandle) return null;
    
    // Try to get product ID from various sources
    let productId = null;
    
    // Method 1: Check for product JSON in script tags
    const productScripts = document.querySelectorAll('script[type="application/json"][data-product-json], script[data-product-json]');
    if (productScripts.length > 0) {
      try {
        const productData = JSON.parse(productScripts[0].textContent);
        if (productData.id) {
          productId = productData.id.toString();
        }
      } catch (e) {
        console.warn('[Recently Viewed] Could not parse product JSON:', e);
      }
    }
    
    // Method 2: Check for product ID in form inputs
    if (!productId) {
      const productForm = document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
          // Try to get product ID from variant
          // This is a fallback - we'll use the handle as ID if needed
        }
      }
    }
    
    // Method 3: Check for data attributes
    if (!productId) {
      const productElement = document.querySelector('[data-product-id], [data-product-handle="' + productHandle + '"]');
      if (productElement) {
        productId = productElement.getAttribute('data-product-id');
      }
    }
    
    // Method 4: Use handle as fallback ID (not ideal but works)
    if (!productId) {
      productId = productHandle;
    }
    
    return {
      handle: productHandle,
      id: productId
    };
  }
  
  // Track product view
  function trackProductView(productHandle, productId) {
    if (!productHandle) {
      console.warn('[Recently Viewed] Cannot track: no product handle');
      return;
    }
    
    const storageKey = 'recently_viewed_products';
    const maxProducts = 12;
    let viewedProducts = [];
    
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        viewedProducts = JSON.parse(stored);
        console.log('[Recently Viewed] Found', viewedProducts.length, 'existing products');
      } else {
        console.log('[Recently Viewed] No existing products found, starting fresh');
      }
    } catch (e) {
      console.error('[Recently Viewed] Error reading localStorage:', e);
      viewedProducts = [];
    }
    
    // Remove if already exists (to move to front)
    const beforeCount = viewedProducts.length;
    viewedProducts = viewedProducts.filter(function(item) {
      return item.handle !== productHandle;
    });
    
    if (beforeCount !== viewedProducts.length) {
      console.log('[Recently Viewed] Removed duplicate product');
    }
    
    // Add to front
    viewedProducts.unshift({
      handle: productHandle,
      id: productId || productHandle,
      timestamp: Date.now()
    });
    
    // Limit to max products
    if (viewedProducts.length > maxProducts) {
      viewedProducts = viewedProducts.slice(0, maxProducts);
    }
    
    // Save to localStorage
    try {
      localStorage.setItem(storageKey, JSON.stringify(viewedProducts));
      console.log('[Recently Viewed] ✓ Successfully tracked product:', productHandle);
      console.log('[Recently Viewed] Total products in storage:', viewedProducts.length);
      
      // Verify it was saved
      const verify = localStorage.getItem(storageKey);
      if (verify) {
        const parsed = JSON.parse(verify);
        console.log('[Recently Viewed] ✓ Verified: Data saved successfully. Products:', parsed.length);
        console.log('[Recently Viewed] Product handles:', parsed.map(function(p) { return p.handle; }));
      } else {
        console.error('[Recently Viewed] ✗ Error: Data not saved!');
      }
    } catch (e) {
      console.error('[Recently Viewed] ✗ Error saving to localStorage:', e);
      if (e.name === 'QuotaExceededError') {
        console.error('[Recently Viewed] localStorage is full!');
      }
    }
  }
  
  // Initialize tracking
  function initTracking() {
    if (!isProductPage()) {
      return;
    }
    
    console.log('[Recently Viewed] Initializing tracking on product page...');
    
    const productData = getProductData();
    if (productData && productData.handle) {
      console.log('[Recently Viewed] Product detected:', productData.handle, productData.id);
      trackProductView(productData.handle, productData.id);
    } else {
      console.warn('[Recently Viewed] Could not detect product data from page');
    }
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTracking);
  } else {
    initTracking();
  }
  
  // Also try after a delay as backup
  setTimeout(initTracking, 1000);
  setTimeout(initTracking, 3000);
})();

